import Axios from 'axios';
import React, { useEffect, useMemo, useRef, useState } from 'react'
import NotData from '../../components/NotData';
import itemTypeList from '../../common/itemTypeList';
import dayjs from 'dayjs';
import NumberPad from '../../components/NumberPad';
import { useNavigate } from 'react-router-dom';
import { Toast } from '../../common/message';
import UserPointExp from '../../common/UserPointExp';

const ItemManagement = () => {

  // 시간 불러오는 부분
  let toDate = new dayjs().format('YYYY-MM-DD');
  let toTime = new dayjs().format('YYYY-MM-DD HH:mm:ss')

  const minusDate = (number)=>{
    const now = new dayjs().subtract(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const plusDate = (number)=>{
    const now = new dayjs().add(number, 'days');
    return now.format('YYYY-MM-DD');
  }

  const toDay = {
    date: toDate,
    time: toTime,
    minusDate,
    plusDate
  }

  const [itemIdx, setItemIdx] = useState(0);
  const basicStore = window.sessionStorage.getItem('basicStore');

  const firstCursor = useRef(null);

  const [books, setBooks] = useState([]);
  const columns = [
    'No', '브랜드', '분류', '제품이름', '가격', '탄방', '둔산', '자양', '충대'
  ];

  const MyStore = window.sessionStorage.getItem('basicStore');
  const [itemType, setItemType] = useState('');
  const [itemSearch, setItemSearch] = useState(''); // 아이템 검색

  const [bcbemeValue, setBcBeMeValue] = useState('');
  const [storeValue, setStoreValue] = useState('');

  // 선택 아이템 데이터
  const [selectItemNo, setSelctItemNo] = useState(0);
  const [selectItemBrand, setSelctItemBrand] = useState('');
  const [selectItemType, setSelctItemType] = useState('');
  const [selectItemName, setSelctItemName] = useState('');
  const [selectItemPrice, setSelctItemPrice] = useState('');

  const[itemTotalCount, setItemTotalCount] = useState(0);

  const [itemCount, setItemCount] = useState(0);
  const [itemIno, setItemIno] = useState(0);

  // item_Log 테이블에 따로 추가될 스테이트
  const [itemUpdateBrand, setItemUpdateBrand] = useState('');
  const [itemUpdateType, setItemUpdateType] = useState('');
  const [itemUpdateName, setItemUpdateName] = useState('');
  const [itemUpdatePrice, setItemUpdatePrice] = useState(0);
  const [itemUpdateCount, setItemUpdateCount] = useState(0);

  const [showNumberPad, setShowNumberPad] = useState(false);
  const [numberPadValue, setNumberPadValue] = useState(0);

  // 아이템 등록된 전체 수량
  const addItemCount = async () => {
    await Axios.get(`/api/itemmanagement/itemtotalcount`)
    .then((res) => {
      if (res.data.length) {
        setItemTotalCount(res.data[0].itemTotalCount);
      } else {
        setItemTotalCount(res.data[0]);
      }
    });
  };

  useEffect(()=>{
    firstCursor.current.focus();

  }, [])

  // 처음 로딩이 끝날 경우 처리할 부분
  useMemo(()=>{
    document.title = '재고 목록';

    addItemCount(); // 아이템 토탈 불러오기
  }, [])
  
  // 숫자 천자리 콤마
  function NumberConvert(num)
  {
    var num_parts = num.toString().split(".");
    num_parts[0] = num_parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    return num_parts.join(".");
  }

  // 수량 업 다운
  const ItemCount_Down5 = ()=>{
    if(itemCount <= 0 || itemCount < 5) return;
    setItemCount(itemCount - 5);
  }
  const ItemCount_Down = ()=>{
    if(itemCount <= 0) return;
    setItemCount(itemCount - 1);
  }
  const ItemCount_Up = ()=>{
    setItemCount(itemCount + 1);
  }
  const ItemCount_Up5 = ()=>{
    setItemCount(itemCount + 5);
  }

  // 검색 버튼 부분
  const searchBtnClick = (e)=>{
    
    e.preventDefault();

    if(!itemSearch) return alert('검색어를 입력해 주세요');
    
    if(itemSearch&& itemType === '전체') {
      return itemNameSearch(); // 제품명만 조회
    }

    if(itemSearch&& itemType !== '전체'){
      return itemTypeNameSearch(); // 분류와 제품명 동시 조회
    } 

    if(!itemSearch&& itemType === '전체') {
      return handleSelect(itemType); // 분류만 조회
    } 
    
    reset();
  };

  // 분류 + 제품명 검색
  const itemTypeNameSearch = async (value)=>{
    await Axios.get('/api/itemmanagement/itemmanagement_typename', {
      params: { searchText: itemSearch, Type: value ?? itemType }
    })
    .then((res)=>{
      if(res.data.length)
      {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    });
    setSelectedRow(-1);
  }

  // 아이템 이름 검색
  const itemNameSearch = async () => {
    await Axios.get(`/api/itemmanagement/search`, { 
      params: { itemSearch: itemSearch }
    })
    .then((res)=>{
      if(res.data.length)
      {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    });
    reset();
  };      

  // 아이템 분류 검색
  const itemTypeSearch = async (value) => {
    await Axios.get(`/api/itemmanagement`, {
      params: { type: value }
    })
    .then(res=>{
      if(res.data.length)
      {
        setBooks(res.data);
      } else {
        setBooks([]);
      }
    });
    reset();
  };

  // 분류 탭 부분
  const handleSelect = (e) => {

    firstCursor.current.focus();
    
    // setItemSearch('');
    // if(e.target.value === '전체') return setBooks([]);
    // itemTypeSearch(e.target.value);
    
    if(itemSearch){
      itemTypeNameSearch(e.target.value);
    } else {
      itemTypeSearch(e.target.value);
    }

    setItemType(e.target.value);
    reset();
  };

  // 재고 차감
  const ItemDown = async ()=>{
    await Axios.put(`/api/itemmanagement/itemdown`, {
      store: window.sessionStorage.getItem('basicStore'), itemIno: selectItemNo, itemCount: itemCount
    })
    .then((res)=>{

    })
  };
  // 재고 증가
  const ItemUp = async ()=>{
    await Axios.put(`/api/itemmanagement/itemup`, {
      store: window.sessionStorage.getItem('basicStore'), itemIno: selectItemNo, itemCount: itemCount
    })
    .then((res)=>{

    })
  };

  // 반출 반입 매입 버튼
  const btnBCBEME = async ()=>{
    if(!selectItemName) return alert('제품을 먼저 선택해 주세요.');
    if(itemCount <= 0) return alert('수량을 확인해 주세요.');
    if(bcbemeValue === '') return alert('반출 / 반입 / 매입 방식을 선택해 주세요.');
    // 매입이 아닐 경우 체크
    if(bcbemeValue === '반출' || bcbemeValue === '반입'){
      if(storeValue === '') return alert('반출 / 반입 / 매입할 매장을 선택해 주세요.');
    }

    if(!window.confirm(`${bcbemeValue} 처리하시겠습니까?`)) return;
    // if(bcbemeValue === '매입'){
    // } else {
    
    // }

    if(bcbemeValue === '반출'){ // 반출처리
      await Axios.post(`/api/itemmanagement/bc`, {
        No: selectItemNo, Brand: selectItemBrand, Type: selectItemType, Name: selectItemName, Count: itemCount,
        Date: toDay.time, T1: MyStore, T2: storeValue, Id: window.sessionStorage.getItem('basicID')
      })
      .then((res)=>{
        ItemDown();
        // 처리시 복사 데이터에 즉시 반영
        setBooks(()=>{
          const copy = [...books]
          switch(basicStore){
            case '탄방점' : copy[itemIdx].i_count_TB -= itemCount; break;
            case '둔산점' : copy[itemIdx].i_count_DS -= itemCount; break;
            case '자양점' : copy[itemIdx].i_count_JY -= itemCount; break;
            case '충대점' : copy[itemIdx].i_count_CD -= itemCount; break;
            default : break;
          }      
          return copy;
        });
        Toast.fire({ icon: "success", text: `${selectItemName} ${itemCount}개 반출 성공` });

        // 포인트 및 기여도 지급
        UserPointExp('재고관리', `${selectItemName} 제품 반출`, 1, 1);
      });
    } else if(bcbemeValue === '반입'){ // 반입처리
      await Axios.post(`/api/itemmanagement/be`, {
        No: selectItemNo, Brand: selectItemBrand, Type: selectItemType, Name: selectItemName, Count: itemCount,
        Date: toDay.time, T1: storeValue, T2: MyStore, Id: window.sessionStorage.getItem('basicID')
      })
      .then((res)=>{
        ItemUp();
        // 처리시 복사 데이터에 즉시 반영
        setBooks(()=>{
          const copy = [...books]
          switch(basicStore){
            case '탄방점' : copy[itemIdx].i_count_TB += itemCount; break;
            case '둔산점' : copy[itemIdx].i_count_DS += itemCount; break;
            case '자양점' : copy[itemIdx].i_count_JY += itemCount; break;
            case '충대점' : copy[itemIdx].i_count_CD += itemCount; break;
            default : break;
          }      
          return copy;
        });
        Toast.fire({ icon: "success", text: `${selectItemName} ${itemCount}개 반입 성공` });
        // 포인트 및 기여도 지급
        UserPointExp('재고관리', `${selectItemName} 제품 반입`, 1, 1);
      });
    } else if(bcbemeValue === '매입'){ // 매입처리
      await Axios.post(`/api/itemmanagement/me`, {
        No: selectItemNo, Brand: selectItemBrand, Type: selectItemType, Name: selectItemName, Count: itemCount,
        Date: toDay.time, T3: MyStore, Id: window.sessionStorage.getItem('basicID')
      })
      .then((res)=>{
        ItemUp();
        // 처리시 복사 데이터에 즉시 반영
        setBooks(()=>{
          const copy = [...books]
          switch(basicStore){
            case '탄방점' : copy[itemIdx].i_count_TB += itemCount; break;
            case '둔산점' : copy[itemIdx].i_count_DS += itemCount; break;
            case '자양점' : copy[itemIdx].i_count_JY += itemCount; break;
            case '충대점' : copy[itemIdx].i_count_CD += itemCount; break;
            default : break;
          }      
          return copy;
        });
        Toast.fire({ icon: "success", text: `${selectItemName} ${itemCount}개 매입 성공` });
        // 포인트 및 기여도 지급
        UserPointExp('재고관리', `${selectItemName} 제품 매입`, 1, 1);
      });
    }
    reset();
  }

  // 제품 신규 추가 버튼
  const btnItemADD = async (e)=>{
    
    if(!itemUpdateBrand) return alert('추가하실 제품의 브랜드를 입력해 주세요.');
    if(!itemUpdateName) return alert('추가하실 제품의 이름을 입력해 주세요.');
    if(itemUpdateType === '전체' || !itemUpdateType) return alert('추가하실 제품의 분류를 확인해 주세요.');

    if(itemType === '일반액상' && !itemUpdateName.includes('mg')){
      return alert('일반액상 제품 추가시 제품명 뒤에는 니코틴 함량과 함께 `mg`라는 단어가 존재해야 합니다. ex) 레드불-9.8mg');
    }
    if(itemType === '모드액상' && !itemUpdateName.includes('MG')){
      return alert('모드액상 제품 추가시 제품명 뒤에는 니코틴 함량과 함께 `MG`라는 단어가 존재해야 합니다. ex) 레드불-3MG');
    }

    if(!window.confirm(`${itemUpdateName} ${NumberConvert(itemUpdatePrice)}원으로 추가하시겠습니까?`)) return;

    // item 테이블에 추가
    await Axios.post(`/api/itemmanagement/itemadd`, {
      Brand: itemUpdateBrand, Type: itemUpdateType, Name: itemUpdateName,
      Price: itemUpdatePrice, Count: itemCount, AddId: window.sessionStorage.getItem('basicID'),
      Date: toDay.time, Store: MyStore
    })
    .then((res)=>{
      Toast.fire({ icon: "success", text: `${selectItemName}가 재고에 추가되었습니다` });
      // 포인트 및 기여도 지급
      UserPointExp('재고관리', `${selectItemName} 제품 추가`, 1, 1);
    });

    // item_Log 테이블에 추가
    await Axios.post(`/api/itemmanagement/itemlogadd`, {
      ItemIno: itemIno ?? 0, Log: '추가', Store: MyStore, Brand: itemUpdateBrand, Type: itemUpdateType, Name: itemUpdateName,
      Price: itemUpdatePrice, Count: itemCount, AddId: window.sessionStorage.getItem('basicID'),
      Date: toDay.time
    })
    .then((res)=>{
      
    });

    // 처리시 복사 데이터에 즉시 반영
    setBooks(()=>{
      if(basicStore === '탄방점'){
        const addDataTB = { i_brand: itemUpdateBrand, i_type: itemUpdateType, i_name: itemUpdateName, i_price: itemUpdatePrice, i_count_TB: itemCount, i_count_DS: 0, i_count_JY: 0, i_count_CD: 0 };
        const copyTB = [...books, addDataTB];
        return copyTB;
      } else if(basicStore === '둔산점'){
        const addDataDS = { i_brand: itemUpdateBrand, i_type: itemUpdateType, i_name: itemUpdateName, i_price: itemUpdatePrice, i_count_TB: 0, i_count_DS: itemCount, i_count_JY: 0, i_count_CD: 0 };
        const copyDS = [...books, addDataDS];
        return copyDS;
      } else if(basicStore === '자양점'){
        const addDataJY = { i_brand: itemUpdateBrand, i_type: itemUpdateType, i_name: itemUpdateName, i_price: itemUpdatePrice, i_count_TB: 0, i_count_DS: 0, i_count_JY: itemCount, i_count_CD: 0 };
        const copyJY = [...books, addDataJY];
        return copyJY;
      } else if(basicStore === '충대점'){
        const addDataCD = { i_brand: itemUpdateBrand, i_type: itemUpdateType, i_name: itemUpdateName, i_price: itemUpdatePrice, i_count_TB: 0, i_count_DS: 0, i_count_JY: 0, i_count_CD: itemCount };
        const copyCD = [...books, addDataCD];
        return copyCD;
      } else {
        setBooks([]);
      }
    });

    addItemCount(); // 아이템 토탈값 다시 호출
    reset(); // 값 리셋
  };

  // 제품 수정 버튼
  const btnItemUpdate = async (e)=>{

    if(
      (itemUpdateBrand === selectItemBrand) && (itemUpdateType === selectItemType) &&
      (itemUpdateName === selectItemName) && (itemUpdatePrice === selectItemPrice) &&
      (itemUpdateCount === itemCount)
      ) return alert('변동된 항목이 없습니다');

    if(!window.confirm(`${selectItemName}를 수정하시겠습니까?`)) return;

    // 수정된 내용들을 item 테이블에 적용
    await Axios.put(`/api/itemmanagement/itemupdate`, {
      itemIno: selectItemNo, Store: MyStore, Brand: itemUpdateBrand, Type: itemUpdateType,
      Name: itemUpdateName, Price: itemUpdatePrice, Count: itemCount,
      UserId: window.sessionStorage.getItem('basicID'), Date: toDay.time,
    })
    .then((res)=>{
      Toast.fire({ icon: "success", text: `${selectItemName} 수정 성공` });
      // 포인트 및 기여도 지급
      UserPointExp('재고관리', `${selectItemName} 제품 수정`, 1, 1);
    });

    // 아이템 수정시 이름 전체 수정 서로 이름이 다를 경우
    if(itemUpdateName !== selectItemName){
      await Axios.put(`/api/itemmanagement/itemupdateTB`, {
        Name: itemUpdateName, SelectName: selectItemName
      });
      await Axios.put(`/api/itemmanagement/itemupdateDS`, {
        Name: itemUpdateName, SelectName: selectItemName
      });
      await Axios.put(`/api/itemmanagement/itemupdateJY`, {
        Name: itemUpdateName, SelectName: selectItemName
      });
      await Axios.put(`/api/itemmanagement/itemupdateCD`, {
        Name: itemUpdateName, SelectName: selectItemName
      });
    }

    // 재고 수정된 내용들을 item_Log 테이블에 기록
    await Axios.post(`/api/itemmanagement/itemupdatelog`, {
      itemIno: selectItemNo ?? 0, Log: '수정', Store: MyStore, 
      i_Brand: selectItemBrand, Brand: itemUpdateBrand, i_Type: selectItemType, Type: itemUpdateType,
      i_Name: selectItemName, Name: itemUpdateName, i_Price: selectItemPrice, Price: itemUpdatePrice,
      i_Count: itemUpdateCount, Count: itemCount, UserId: window.sessionStorage.getItem('basicID'),
      Date: toDay.time,
    })
    .then((res)=>{      
      
    });

    // 수정된 값으로 교체
    setBooks(()=>{
      const copy = [...books]
      switch(basicStore){
        case '탄방점' : copy[itemIdx].i_brand = itemUpdateBrand; copy[itemIdx].i_type = itemUpdateType; copy[itemIdx].i_name = itemUpdateName; copy[itemIdx].i_price = itemUpdatePrice; copy[itemIdx].i_count_TB = itemCount; break;
        case '둔산점' : copy[itemIdx].i_brand = itemUpdateBrand; copy[itemIdx].i_type = itemUpdateType; copy[itemIdx].i_name = itemUpdateName; copy[itemIdx].i_price = itemUpdatePrice; copy[itemIdx].i_count_DS = itemCount; break;
        case '자양점' : copy[itemIdx].i_brand = itemUpdateBrand; copy[itemIdx].i_type = itemUpdateType; copy[itemIdx].i_name = itemUpdateName; copy[itemIdx].i_price = itemUpdatePrice; copy[itemIdx].i_count_JY = itemCount; break;
        case '충대점' : copy[itemIdx].i_brand = itemUpdateBrand; copy[itemIdx].i_type = itemUpdateType; copy[itemIdx].i_name = itemUpdateName; copy[itemIdx].i_price = itemUpdatePrice; copy[itemIdx].i_count_CD = itemCount; break;
        default : break;
      }
      return copy;
    });

    reset(); // 값 리셋
  };

  // 제품 삭제 버튼
  const btnItemDelete = async (e)=>{
    e.preventDefault();

    if(!window.confirm(`${selectItemName}를 삭제하시겠습니까?`)) return;

    // 아이템 삭제처리
    await Axios.delete(`/api/itemmanagement/itemdelete/` + itemIno)
    .then((res)=>{
      Toast.fire({ icon: "success", text: `${selectItemName} 제품 삭제` });
      // 포인트 및 기여도 지급
      UserPointExp('재고관리', `${selectItemName} 제품 삭제`, 1, 1);
    });

    // 아이템 삭제 로그 기록
    await Axios.post(`/api/itemmanagement/itemdeletelog`, {
      ItemIno: itemIno ?? 0, Log: '삭제', Store: MyStore, Brand: itemUpdateBrand,
      Type: itemUpdateType, Name: itemUpdateName, Price: itemUpdatePrice,
      Count: itemCount, AddId: window.sessionStorage.getItem('basicID'), Date: toDay.time
    })
    .then((res)=>{
      
    });

    setBooks(books.filter(item => item.no !== itemIno));
    addItemCount();

    reset(); // 리셋
  }

  // 리셋 함수
  const reset = ()=>{
    setSelctItemNo(0);
    setSelctItemBrand('');
    setSelctItemType('');
    setSelctItemName('');
    setSelctItemPrice(0);
    setItemCount(0);

    setItemIno(0);
    setItemUpdateBrand('');
    setItemUpdateType('');
    setItemUpdateName('');
    setItemUpdatePrice(0);
    setItemUpdateCount(0);

    setBcBeMeValue('');
    setStoreValue('');

    setShowNumberPad(false);

    setSelectedRow(-1);
  }

  // 셀렉트 테스트
  const [selectedRow, setSelectedRow] = useState(-1);

  const navigate = useNavigate();

  const hacaUpdate = async ()=>{

    if(!window.confirm('탄방점, 둔산점의 지금까지 판매된 모든 하카 이름을 가진 제품들의 분류를 하카로 재지정 합니다')) return;

    await Axios.put(`/api/itemmanagement/hacaupdate`)
    .then((res)=>{
      Toast.fire({ icon: "success", text: `모든 하카 관련 품목들이 업데이트 되었습니다` });
    })

  }

  return (
    <div className='p-3 flex flex-col gap-3 whitespace-nowrap'>
      <div className='flex justify-between items-center'>
        <ul className='flex gap-3'>
          <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto border-[1px] border-yellow-500 rounded-md`} onClick={(e)=>navigate('/itemmanagement/itemlist')}>재고 목록</li>
          <li className={`hover:underline cursor-pointer py-2 px-3 overflow-x-auto}`} onClick={(e)=>navigate('/itemmanagement/itemlog')}>재고 수정 내역</li>
        </ul>
        {/* <div className={`${window.sessionStorage.getItem('basicPosition') !== '점장' && 'hidden'}`}>
          <button className='text-yellow-400' onClick={hacaUpdate}>하카 업데이트</button>
        </div> */}
      </div>
      
      <div className='grid grid-cols-1 md:flex md:justify-between text-sm md:h-[calc(100vh-8.9rem)] gap-1'>

        {/* 메인 */}
        <div className='relative border-[1px] border-gray-500 w-full md:w-3/4 md:h-full h-[60vh] overflow-y-auto'>
          <table id='testTable' className='w-full'>
            <thead className='bg-[#1E1E1E]/90 whitespace-nowrap text-center sticky top-0 z-0'>
              <tr className='border-b-[1px] border-gray-500'>
                {columns.map((column) => (
                  <th className='p-3' key={column}>{column}</th>
                ))}
              </tr>
            </thead>
            <tbody className='text-center'>
              {
                books.length ?
                books.map((book, idx) => (                  
                  <tr className=
                    {`
                      duration-150 decoration-yellow-600 whitespace-nowrap active:scale-[0.98] active:opacity-80
                      ${selectedRow === idx ? 'bg-[#1E1E1E] font-bold underline decoration-[3px]' : 'even:bg-[#3E3E3E]'}
                    `}
                    key={idx} onClick={(e)=>{
                    setSelectedRow(idx);

                    setItemUpdateBrand(book.i_brand);
                    setItemUpdateType(book.i_type);
                    setItemUpdateName(book.i_name);
                    setItemUpdatePrice(book.i_price);
                    
                    (MyStore === '탄방점' && setItemUpdateCount(book.i_count_TB)) || (MyStore === '둔산점' && setItemUpdateCount(book.i_count_DS)) ||
                    (MyStore === '자양점' && setItemUpdateCount(book.i_count_JY)) || (MyStore === '충대점' && setItemUpdateCount(book.i_count_CD))  

                    setItemIdx(idx);
                    setItemIno(book.no);
                    setSelctItemNo(book.no);
                    setSelctItemBrand(book.i_brand);
                    setSelctItemType(book.i_type);
                    setSelctItemName(book.i_name);
                    setSelctItemPrice(book.i_price);

                    setNumberPadValue(book.i_price);

                    setBcBeMeValue('');
                    setStoreValue('');

                    window.sessionStorage.setItem('select_copy', book.i_name);

                    (MyStore === '탄방점' && setItemCount(book.i_count_TB)) || (MyStore === '둔산점' && setItemCount(book.i_count_DS)) ||
                    (MyStore === '자양점' && setItemCount(book.i_count_JY)) || (MyStore === '충대점' && setItemCount(book.i_count_CD))
                  }}>
                    <td className='p-2.5'>{idx + 1}</td>
                    <td className='p-2.5 border-x-[1px] border-gray-500'>{book.i_brand}</td>
                    <td className='p-2.5 border-x-[1px] border-gray-500'>{book.i_type}</td>
                    <td className='p-2.5 border-x-[1px] border-gray-500'>{book.i_name}</td>
                    <td className='p-2.5 border-x-[1px] border-gray-500'>{`${NumberConvert(book.i_price)} 원`}</td>
                    <td className={`p-2.5'${book.i_count_TB < 0 && ' text-red-400 animate-pulse '}`}>{book.i_count_TB === 0 ? '-' : book.i_count_TB}</td>
                    <td className={`p-2.5'${book.i_count_DS < 0 && ' text-red-400 animate-pulse '}`}>{book.i_count_DS === 0 ? '-' : book.i_count_DS}</td>
                    <td className={`p-2.5'${book.i_count_JY < 0 && ' text-red-400 animate-pulse '}`}>{book.i_count_JY === 0 ? '-' : book.i_count_JY}</td>
                    <td className={`p-2.5'${book.i_count_CD < 0 && ' text-red-400 animate-pulse '}`}>{book.i_count_CD === 0 ? '-' : book.i_count_CD}</td>
                  </tr>
                ))
                :
                <tr className='relative'>
                  <td className='absolute w-full top-[30vh] left-auto'>
                    <NotData/>
                  </td>
                </tr>
              }
            </tbody>
          </table>
        </div>

        {/* 사이드 */}
        <div className='md:w-1/4 w-full md:overflow-y-auto bg-[#424242] border-[1px] border-gray-500'>
          <div className='bg-[#0067BD] py-2 text-center'>
            <div className='text-left pl-3'>
              <span>※ </span>
              <span className='text-amber-400 font-bold'>{MyStore ?? '...'}</span>
              <span> 매장 재고관리</span>
            </div>
          </div>
          
          <div className='p-3 flex flex-col gap-2'>

            <div className='flex justify-center items-center bg-[#2E2E2E] h-12 p-3 rounded-md'>
              <p className='text-center'>등록된 제품: {NumberConvert(itemTotalCount ?? 0)} 개</p>
            </div>

            {/* 아이템 이름 검색 */}
            <div className=''>
              <form className='w-full flex items-center gap-2' autoComplete='off'>
                <input ref={firstCursor} id='searchInput' value={itemSearch} onChange={(e)=>setItemSearch(e.target.value)} className='bg-[#2E2E2E] h-12 w-full p-2 rounded-md text-center outline-none border-[1px] border-gray-400' type='search' placeholder='브랜드 or 이름' onDoubleClick={()=>setItemSearch(window.sessionStorage.getItem('select_copy'))} />
                <input className='bg-blue-600 px-3 py-2 h-12 rounded-sm w-[30%] cursor-pointer' type='submit' value='검색' onClick={searchBtnClick} />
              </form>
            </div>

            {/* 제품 조회 */}
            <div>
              <div className='flex items-center gap-2'>
                <select id='storeInput' className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400' value={itemType} onChange={handleSelect} >
                  {itemTypeList.map((item, idx) => (
                    <option value={item} key={idx}>
                      {item}
                    </option>
                  ))}
                </select>                
              </div>
            </div>

            {/* 언더라인 */}
            <div className='border-b-[1px] border-gray-400 py-1'></div>

            <div className='flex gap-2'>
              <div className='w-full'>
                <p>브랜드</p>
                <input type='text' value={itemUpdateBrand} onChange={(e)=>setItemUpdateBrand(e.target.value)} className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md outline-none border-[1px] border-gray-400 text-center' placeholder='브랜드' />
              </div>
              <div className='w-full'>
                <p>분류</p>
                <select id='storeInput' value={itemUpdateType} onChange={(e)=>setItemUpdateType(e.target.value)} className='w-full mt-1 h-12 bg-[#2E2E2E] p-2 px-2 rounded-md cursor-pointer outline-none border-[1px] border-gray-400' >
                  {itemTypeList.map((item) => (
                    <option value={item} key={item}>
                      {item}
                    </option>
                  ))}
                </select>
              </div>              
            </div>

            {/* 제품이름 */}
            <div className=''>
              <p>제품 이름</p>
              <input className='bg-[#2E2E2E] mt-2 rounded-t-md w-full h-20 text-center font-bold border-b-[1px] hover:border-blue-500 border-gray-400' placeholder='〈 제품 이름을 입력하세요 〉' type='text' 
                value={itemUpdateName} onChange={(e)=>{
                setItemUpdateName(e.target.value);
              }} />
            </div>
            
            {/* 제품 가격 */}
            <div className='flex flex-col justify-center items-center gap-3 w-full'>
              <div className='flex flex-col gap-3 w-full'>
                <p className='whitespace-nowrap'>제품 가격</p>
                <div className='flex gap-2'>
                  <input id='discountText' className='bg-[#2E2E2E] w-full h-[40px] rounded-md text-center border-[1px] border-gray-300' type='text' disabled 
                  value={numberPadValue ? `${NumberConvert(numberPadValue)} 원` : '0 원'}/>
                </div>
              </div>

              {/* 키패드 */}
              <div className='w-full flex flex-col gap-3'>              
                <div>
                  <button className='bg-[#2E2E2E] h-[40px] w-[100%] rounded-md text-center border-[1px] border-[#1F8BE2]' onClick={()=>{                  

                    // 패드 값이 없을 경우 초기화
                    if(!numberPadValue){
                      setNumberPadValue('');
                    }

                    // 패드가 열리면 가격 초기화 아니면 복원
                    if(!showNumberPad){
                      setNumberPadValue('');
                      setItemUpdatePrice(0);
                    } else {
                      setNumberPadValue(selectItemPrice);
                      setItemUpdatePrice(selectItemPrice);
                    }

                    // 키패드 버튼 누를시 열고 닫고
                    setShowNumberPad(!showNumberPad);
                  }}>
                    {`${showNumberPad ? '키패드 닫기' : '키패드 열기'}`}
                  </button>
                </div>
                <div className={`${showNumberPad ? 'inline' : 'hidden'} grid grid-cols-1 gap-3 border-gray-500 border-2 bg-[#2E2E2E] rounded-md p-3`}>
                  <NumberPad setNumberPadValue={setNumberPadValue} numberPadValue={numberPadValue} />
                  <div className='grid grid-cols-1 gap-3'>
                    <button className='bg-blue-500 p-2 duration-150 rounded-md hover:scale-95 active:bg-[#2E2E2E]' onClick={()=>{
                      if(numberPadValue.length >= 8) return alert(`제품의 가격이 너무 큽니다`);
                      setShowNumberPad(false);
                      setItemUpdatePrice(numberPadValue);
                    }}>
                      적용
                    </button>
                    {/* <button className='bg-blue-500 p-2 duration-150 rounded-md hover:scale-95 active:bg-[#2E2E2E]' onClick={()=>{
                      setNumberPadValue('');
                      setItemUpdatePrice(0);
                    }}>
                      취소
                    </button> */}
                  </div>
                </div>
              </div>

            </div>

            {/* 제품 수량 */}
            <div className='flex flex-col w-full justify-center gap-3'>
              <p className='whitespace-nowrap'>제품 수량</p>
              <div className='flex justify-center items-center gap-1 w-full'>
                <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
                onClick={ItemCount_Down5}>
                  {'《'}
                </button>
                <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
                onClick={ItemCount_Down}>
                  {'〈'}
                </button>
                <div className='bg-[#2E2E2E] py-2.5 rounded-md'>
                  <p id='itemCountValue' className='whitespace-nowrap w-20 text-center'>
                    {itemCount} 개
                  </p>
                </div>
                <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
                onClick={ItemCount_Up}>
                  {'〉'}
                </button>
                <button className='p-2 bg-[#2E2E2E] border-[1px] border-[#1F8BE2] rounded-sm w-full'
                onClick={ItemCount_Up5}>
                  {'》'}
                </button>
              </div>
            </div>

            {/* 반출/반입/매입 */}
            <div className='flex flex-col gap-2 bg-[#2E2E2E] rounded-md p-2'>
              <div className='flex justify-between gap-3'>
                <p className=''>반출 / 반입 / 매입</p>
              </div>

              {/* 결제 현황 */}              
              <ul className="grid w-full gap-1 grid-cols-3">
                <li>
                  <input type="checkbox" id="bc" value="반출" className="hidden peer" checked={bcbemeValue === '반출' ? true : false} onChange={()=>{
                    if(!selectItemNo || !selectItemName) return alert('제품을 먼저 선택하세요');
                    if(bcbemeValue === '반출') return setBcBeMeValue('');
                    setBcBeMeValue('반출');
                    setStoreValue('');
                    setItemCount(0);
                  }}/>
                  <label htmlFor="bc" className="duration-150 inline-flex items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">                           
                    <div className="flex justify-center items-center">
                      <div className="w-full text-base whitespace-nowrap">반출</div>
                    </div>
                  </label>
                </li>
                <li>
                  <input type="checkbox" id="be" value="반입" className="hidden peer" checked={bcbemeValue === '반입' ? true : false} onChange={(()=>{
                    if(!selectItemNo || !selectItemName) return alert('제품을 먼저 선택하세요');
                    if(bcbemeValue === '반입') return setBcBeMeValue('');
                    setBcBeMeValue('반입');
                    setStoreValue('');
                    setItemCount(0);
                  })}/>
                  <label htmlFor="be" className="duration-150 inline-flex items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">
                    <div className="flex justify-center items-center">
                      <div className="w-full text-base whitespace-nowrap">반입</div>
                    </div>
                  </label>
                </li>
                <li>
                  <input type="checkbox" id="me" value="매입" className="hidden peer" checked={bcbemeValue === '매입' ? true : false} onChange={(()=>{
                    if(!selectItemNo || !selectItemName) return alert('제품을 먼저 선택하세요');
                    if(bcbemeValue === '매입') return setBcBeMeValue('');
                    setBcBeMeValue('매입');
                    setItemCount(0);
                    setStoreValue('');
                  })}/>
                  <label htmlFor="me" className="duration-150 inline-flex items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">
                    <div className="flex justify-center items-center">
                      <div className="w-full text-base whitespace-nowrap">매입</div>
                    </div>
                  </label>
                </li>
              </ul>

              {/* 매장선택 */}
              <div className={(!bcbemeValue || bcbemeValue === '매입' ? 'hidden' : '?' && storeValue ? 'animate-none flex flex-col gap-2' : 'flex flex-col gap-2 animate-pulse hover:animate-none')}>
                <div className='flex justify-between gap-3'>
                  <p>{(bcbemeValue === '반출' && '반출할 매장 선택') || (bcbemeValue === '반입' && '반입할 매장 선택')}</p>
                </div>

                {/* 반출 반입 매입 할 매장 */}
                <ul className="grid w-full gap-1 grid-cols-3">
                  <li className={MyStore === '탄방점' ? 'hidden' : 'inline'}>
                    <input type="checkbox" id="tb" value="탄방점" className="hidden peer" checked={storeValue === '탄방점' ? true : false} onChange={(e)=>{
                      if(storeValue === '탄방점') return setStoreValue('');
                      setStoreValue('탄방점');
                    }}/>
                    <label htmlFor="tb" className="inline-flex duration-150 items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">
                      <div className="flex justify-center items-center">
                        <div className="w-full text-base whitespace-nowrap">탄방</div>
                      </div>
                    </label>
                  </li>
                  <li className={MyStore === '둔산점' ? 'hidden' : 'inline'}>
                    <input type="checkbox" id="ds" value="둔산점" className="hidden peer" checked={storeValue === '둔산점' ? true : false} onChange={((e)=>{
                      if(storeValue === '둔산점') return setStoreValue('');
                      setStoreValue('둔산점');
                    })}/>
                    <label htmlFor="ds" className="inline-flex duration-150 items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">
                      <div className="flex justify-center items-center">
                        <div className="w-full text-base whitespace-nowrap">둔산</div>
                      </div>
                    </label>
                  </li> 
                  <li className={MyStore === '자양점' ? 'hidden' : 'inline'}>
                    <input type="checkbox" id="jy" value="자양점" className="hidden peer" checked={storeValue === '자양점' ? true : false} onChange={((e)=>{
                      if(storeValue === '자양점') return setStoreValue('');
                      setStoreValue('자양점');
                    })}/>
                    <label htmlFor="jy" className="inline-flex duration-150 items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">
                      <div className="flex justify-center items-center">
                        <div className="w-full text-base whitespace-nowrap">자양</div>
                      </div>
                    </label>
                  </li>
                  <li className={MyStore === '충대점' ? 'hidden' : 'inline'}>
                    <input type="checkbox" id="cd" value="충대점" className="hidden peer" checked={storeValue === '충대점' ? true : false} onChange={((e)=>{
                      if(storeValue === '충대점') return setStoreValue('');
                      setStoreValue('충대점');
                    })}/>
                    <label htmlFor="cd" className="inline-flex duration-150 items-center justify-center w-full px-5 py-2 rounded-lg cursor-pointer hover:text-gray-300 border-gray-700 border-2 peer-checked:border-blue-500 peer-checked:text-gray-200 text-gray-200 bg-gray-800 hover:bg-gray-700">
                      <div className="flex justify-center items-center">
                        <div className="w-full text-base whitespace-nowrap">충대</div>
                      </div>
                    </label>
                  </li>
                </ul>
              </div>
              
              {/* 반출 반입 매입 버튼 */}
              <div className={!bcbemeValue ? 'hidden' : 'flex flex-col gap-2 pt-2'}>
                <button className='bg-[#2E2E2E] h-12 w-[100%] rounded-md text-center border-[1px] border-yellow-300' onClick={btnBCBEME} >
                  {bcbemeValue !== '매입' ? storeValue ? bcbemeValue === '반출' ? `${storeValue}으로 ${bcbemeValue}` : `${storeValue}에서 ${bcbemeValue}` : `반출 / 반입 / 매입 등록` : `${basicStore} 매입 등록`}
                </button>
              </div>

            </div>
            
            {/* 언더라인 */}
            <div className='border-b-[1px] border-gray-400 py-1'></div>

            <div className='flex flex-col gap-2 pt-2'>
              <div>
                <button className='bg-[#2E2E2E] h-[40px] w-[100%] rounded-md text-center border-[1px] border-[#1F8BE2]' onClick={btnItemADD}>
                  제품 신규 추가
                </button>
              </div>
              <div className='flex justify-center items-center gap-2'>
                <button className='bg-[#2E2E2E] h-[40px] w-full rounded-md text-center border-[1px] border-yellow-300' onClick={btnItemUpdate}>
                  제품 수정
                </button>
                <button className='bg-[#2E2E2E] h-[40px] w-full rounded-md text-center border-[1px] border-yellow-300' onClick={btnItemDelete}>
                  제품 삭제
                </button>
              </div>
            </div>

          </div>
        </div>
        
      </div>

    </div>
  )
}

export default ItemManagement